import React from "react";
import "../Styles/BlogCard.css";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();
  const { id, image, title, description, author } = blog;

  return (
    <div
      className="blog-card"
      onClick={() => navigate(`/blogs/${id}`)}
      style={{ cursor: "pointer" }}
    >
      <div className="blog-content">
        <img src={image} alt={title} className="blog-image" />

        <div className="blog-meta">
          <span className="blog-tag">Self Care</span>
          <p className="blog-author">~ {author}</p>
        </div>

        <h3 className="blog-title">{title}</h3>

        <p className="blog-description">
          {description?.length > 60
            ? `${description.slice(0, 60)}...`
            : description}
        </p>
      </div>
    </div>
  );
};

export default BlogCard;
